var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll ver"},[_c('script',{attrs:{"id":"gb_widget_script","type":"module","src":_vm.widgetSrc,"data-skip-autostart":""},on:{"load":_vm.initWidget}})])
}
var staticRenderFns = []

export { render, staticRenderFns }